import { render, staticRenderFns } from "./linkagecenter2.vue?vue&type=template&id=b3cb6232"
import script from "./linkagecenter2.vue?vue&type=script&lang=js"
export * from "./linkagecenter2.vue?vue&type=script&lang=js"
import style0 from "./linkagecenter2.vue?vue&type=style&index=0&id=b3cb6232&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports